import * as utils from '@/utils';

export default ({Vue, store}) => {

  Vue.prototype.$u
    = store.$u
    = utils;
}
